import React from 'react';

import Table from './Table';
import data from '../../data/site';

const Stats = () => (
  <div>
    <h3>Some stats about this site</h3>
    <Table
      data={data}
    />
  </div>
);

export default Stats;
